"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLastMinuteOrder = isLastMinuteOrder;
function isLastMinuteOrder(departureAtUtcTimestamp, lastMinuteThresholdInHours) {
    const nowTimestamp = new Date().getTime();
    const millisecondsUntilDeparture = departureAtUtcTimestamp - nowTimestamp;
    return millisecondsUntilDeparture < lastMinuteThresholdInHours * 60 * 60 * 1000;
}
//# sourceMappingURL=isLastMinuteOrder.js.map